export const teamDirectory = {
  contacts: [
    { name: 'Fullstack Team Lead', role: 'Senior Fullstack Engineer', email: 'fullstack-lead@company.com', slack: '@fullstack-lead' },
    { name: 'Frontend Architect', role: 'Frontend Architecture', email: 'frontend-arch@company.com', slack: '@frontend-arch' },
    { name: 'Backend Architect', role: 'Backend Architecture', email: 'backend-arch@company.com', slack: '@backend-arch' },
    { name: 'Product Manager', role: 'Product', email: 'product@company.com', slack: '@product-manager' }
  ],
  mentors: [
    { name: 'Senior Fullstack Mentor', expertise: 'End-to-end Development & Architecture', availability: 'Mon-Fri 2-4 PM' },
    { name: 'Frontend Mentor', expertise: 'React, TypeScript, UI/UX Implementation', availability: 'Tue/Thu 10 AM-12 PM' },
    { name: 'Backend Mentor', expertise: 'APIs, Databases, System Design', availability: 'Wed/Fri 3-5 PM' }
  ],
  collaborators: [
    { team: 'Design Team', contact: 'design-lead@company.com', purpose: 'UI/UX Implementation' },
    { team: 'DevOps Team', contact: 'devops@company.com', purpose: 'Deployment & Infrastructure' },
    { team: 'QA Team', contact: 'qa-lead@company.com', purpose: 'End-to-end Testing' },
    { team: 'Security Team', contact: 'security@company.com', purpose: 'Security Reviews' }
  ],
  channels: {
    primary: '#fullstack-team',
    announcements: '#fullstack-announcements',
    help: '#fullstack-help',
    frontend: '#frontend-discussions',
    backend: '#backend-discussions',
    architecture: '#system-architecture',
    deployment: '#deployment-support'
  }
};
